import { useEffect, useState } from 'react';

import { removeParamsFromUrl, setParamsToUrl } from 'utils/urlUtils';

export default function useDebounceSearch({ initialQuery, delay = 500 }) {
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        if (searchQuery && searchQuery.length > 0) {
          setParamsToUrl({ query: searchQuery, page: 1 });
        } else {
          removeParamsFromUrl({ query: '' });
        }
      }, delay);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [searchQuery, delay], // Only re-call effect if value or delay changes
  );

  return {
    searchQuery,
    handleQueryChange: setSearchQuery,
  };
}
